<app-side-menu>
  <div class="product-form-container">
    <!-- Header -->
    <div class="header">
      <div class="header-content">
        <div class="title-section">
          <h1><i class="fa-solid fa-box"></i> {{pageTitle}}</h1>
          <p>{{isEditMode ? 'Edite as informações do produto' : 'Preencha as informações para criar um novo produto'}}</p>
        </div>
        <button class="btn-secondary" (click)="cancel()">
          <i class="fa-solid fa-arrow-left"></i>
          Voltar
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading && isEditMode" class="loading-state">
      <i class="fa-solid fa-spinner fa-spin"></i>
      <p>Carregando produto...</p>
    </div>

    <!-- Form -->
    <div *ngIf="!isLoading || !isEditMode" class="form-container">
      <form [formGroup]="productForm" (ngSubmit)="onSubmit()">
        <div class="form-grid">
          <!-- Informações Básicas -->
          <div class="form-section">
            <h3><i class="fa-solid fa-info-circle"></i> Informações Básicas</h3>
            
            <div class="form-row">
              <div class="form-group">
                <label for="code">Código do Produto *</label>
                <input 
                  type="text" 
                  id="code"
                  formControlName="code" 
                  class="form-control"
                  [class.is-invalid]="productForm.get('code')?.invalid && productForm.get('code')?.touched"
                  placeholder="Ex: PLAN-SEMANAL-001">
                <div class="invalid-feedback" *ngIf="getFieldError('code')">
                  {{getFieldError('code')}}
                </div>
              </div>
              
              <div class="form-group">
                <label for="name">Nome do Produto *</label>
                <input 
                  type="text" 
                  id="name"
                  formControlName="name" 
                  class="form-control"
                  [class.is-invalid]="productForm.get('name')?.invalid && productForm.get('name')?.touched"
                  placeholder="Ex: Plano Semanal LOCA9Motos">
                <div class="invalid-feedback" *ngIf="getFieldError('name')">
                  {{getFieldError('name')}}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="type">Tipo *</label>
                <select 
                  id="type"
                  formControlName="type" 
                  class="form-control"
                  [class.is-invalid]="productForm.get('type')?.invalid && productForm.get('type')?.touched">
                  <option value="">Selecione o tipo</option>
                  <option *ngFor="let type of productTypes" [value]="type.value">
                    {{type.label}}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="getFieldError('type')">
                  {{getFieldError('type')}}
                </div>
              </div>
              
              <div class="form-group">
                <label for="billingCycle">Ciclo de Cobrança *</label>
                <select 
                  id="billingCycle"
                  formControlName="billingCycle" 
                  class="form-control"
                  [class.is-invalid]="productForm.get('billingCycle')?.invalid && productForm.get('billingCycle')?.touched">
                  <option *ngIf="requiresBillingDetails(productForm.get('type')?.value)" value="">Selecione o ciclo</option>
                  <option *ngFor="let cycle of billingCycles" [value]="cycle.value">
                    {{cycle.label}}
                  </option>
                </select>
                <small class="text-muted" *ngIf="!requiresBillingDetails(productForm.get('type')?.value)">
                  Para venda de item, o ciclo de cobrança é definido como "Por Unidade".
                </small>
                <div class="invalid-feedback" *ngIf="getFieldError('billingCycle')">
                  {{getFieldError('billingCycle')}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="description">Descrição *</label>
              <textarea 
                id="description"
                formControlName="description" 
                class="form-control"
                [class.is-invalid]="productForm.get('description')?.invalid && productForm.get('description')?.touched"
                rows="3"
                placeholder="Descreva o produto em detalhes..."></textarea>
              <div class="invalid-feedback" *ngIf="getFieldError('description')">
                {{getFieldError('description')}}
              </div>
            </div>
          </div>

          <!-- Configurações de Preço e Duração -->
          <div class="form-section">
            <h3><i class="fa-solid fa-dollar-sign"></i> Preço e Duração</h3>
            
            <div class="form-row">
              <div class="form-group" *ngIf="requiresBillingDetails(productForm.get('type')?.value)">
                <label for="days">Duração (dias) *</label>
                <input 
                  type="number" 
                  id="days"
                  formControlName="days" 
                  class="form-control"
                  [class.is-invalid]="productForm.get('days')?.invalid && productForm.get('days')?.touched"
                  min="1"
                  placeholder="7">
                <div class="invalid-feedback" *ngIf="getFieldError('days')">
                  {{getFieldError('days')}}
                </div>
              </div>
              
              <div class="form-group">
                <label for="basePrice">Preço Base (R$) *</label>
                <input
                  type="text"
                  id="basePrice"
                  formControlName="basePrice"
                  class="form-control"
                  appNumberMask
                  [decimals]="2"
                  [class.is-invalid]="productForm.get('basePrice')?.invalid && productForm.get('basePrice')?.touched"
                  placeholder="89,90">
                <div class="invalid-feedback" *ngIf="getFieldError('basePrice')">
                  {{getFieldError('basePrice')}}
                </div>
              </div>
            </div>

            <div class="form-row" *ngIf="requiresBillingDetails(productForm.get('type')?.value)">
              <div class="form-group">
                <label for="depositAmount">Valor da Caução (R$) *</label>
                <input
                  type="text"
                  id="depositAmount"
                  formControlName="depositAmount"
                  class="form-control"
                  appNumberMask
                  [decimals]="2"
                  [class.is-invalid]="productForm.get('depositAmount')?.invalid && productForm.get('depositAmount')?.touched"
                  placeholder="0,00">
                <div class="invalid-feedback" *ngIf="getFieldError('depositAmount')">
                  {{getFieldError('depositAmount')}}
                </div>
              </div>
            </div>
          </div>

          <!-- Configurações Adicionais -->
          <div class="form-section">
            <h3><i class="fa-solid fa-cog"></i> Configurações Adicionais</h3>

            <div class="checkbox-group">
              <div class="form-check">
                <input
                  type="checkbox"
                  id="isActive"
                  formControlName="isActive"
                  class="form-check-input">
                <label class="form-check-label" for="isActive">
                  Produto ativo
                </label>
              </div>

              <div class="form-check" *ngIf="requiresBillingDetails(productForm.get('type')?.value)">
                <input
                  type="checkbox"
                  id="includeInsurance"
                  formControlName="includeInsurance"
                  class="form-check-input">
                <label class="form-check-label" for="includeInsurance">
                  Incluir seguro
                </label>
              </div>

              <div class="form-check" *ngIf="requiresBillingDetails(productForm.get('type')?.value)">
                <input
                  type="checkbox"
                  id="includeMaintenance"
                  formControlName="includeMaintenance"
                  class="form-check-input">
                <label class="form-check-label" for="includeMaintenance">
                  Incluir manutenção
                </label>
              </div>

              <div class="form-check" *ngIf="requiresBillingDetails(productForm.get('type')?.value)">
                <input
                  type="checkbox"
                  id="isPlanSale"
                  formControlName="isPlanSale"
                  class="form-check-input">
                <label class="form-check-label" for="isPlanSale">
                  <strong>É plano de venda parcelada (ex.: Plano Realize)</strong>
                </label>
              </div>
            </div>
          </div>

          <!-- Configurações do Plano Realize -->
          <div class="form-section" *ngIf="isPlanSaleChecked">
            <h3><i class="fa-solid fa-sliders"></i> Configurações do Plano</h3>

            <div class="form-row">
              <div class="form-group">
                <label for="installments">Número de Parcelas</label>
                <input
                  type="number"
                  id="installments"
                  formControlName="installments"
                  class="form-control"
                  min="1"
                  placeholder="Ex: 52">
                <small class="text-muted">Total de parcelas do plano.</small>
              </div>

              <div class="form-group">
                <label for="paymentBank">Banco de Pagamento dos Boletos</label>
                <select
                  id="paymentBank"
                  formControlName="paymentBank"
                  class="form-control">
                  <option [ngValue]="null">Selecione o banco</option>
                  <option *ngFor="let bank of paymentBanks" [value]="bank.value">
                    {{ bank.label }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="maxVehicles">Limite de Veículos do Plano</label>
                <input
                  type="number"
                  id="maxVehicles"
                  formControlName="maxVehicles"
                  class="form-control"
                  min="1"
                  placeholder="Ex: 100">
                <small class="text-muted">Deixe em branco para sem limite.</small>
              </div>

              <div class="form-group">
                <label for="preventiveMaintenanceMonthlyLimit">Preventivas por Mês</label>
                <input
                  type="number"
                  id="preventiveMaintenanceMonthlyLimit"
                  formControlName="preventiveMaintenanceMonthlyLimit"
                  class="form-control"
                  min="0"
                  placeholder="Ex: 1">
                <small class="text-muted">Número máximo de OS preventivas por mês por veículo.</small>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="penultimateInstallmentAdditional">Acréscimo na Penúltima Parcela (R$)</label>
                <input
                  type="text"
                  id="penultimateInstallmentAdditional"
                  formControlName="penultimateInstallmentAdditional"
                  class="form-control"
                  appNumberMask
                  [decimals]="2"
                  placeholder="0,00">
                <small class="text-muted">Valor extra cobrado junto com a penúltima parcela.</small>
              </div>
            </div>

            <div class="checkbox-group mt-2">
              <div class="form-check">
                <input
                  type="checkbox"
                  id="isDepositRefundable"
                  formControlName="isDepositRefundable"
                  class="form-check-input">
                <label class="form-check-label" for="isDepositRefundable">
                  Caução reembolsável
                </label>
              </div>

              <div class="form-check">
                <input
                  type="checkbox"
                  id="includesRoadsideSupport"
                  formControlName="includesRoadsideSupport"
                  class="form-check-input">
                <label class="form-check-label" for="includesRoadsideSupport">
                  Inclui suporte de rua
                </label>
              </div>

              <div class="form-check">
                <input
                  type="checkbox"
                  id="includesVehicleSubstitution"
                  formControlName="includesVehicleSubstitution"
                  class="form-check-input">
                <label class="form-check-label" for="includesVehicleSubstitution">
                  Inclui substituição de veículo
                </label>
              </div>

              <div class="form-check">
                <input
                  type="checkbox"
                  id="exclusiveVehicles"
                  formControlName="exclusiveVehicles"
                  class="form-check-input">
                <label class="form-check-label" for="exclusiveVehicles">
                  Veículos exclusivos do plano (não podem ser usados em outros planos)
                </label>
              </div>

              <div class="form-check">
                <input
                  type="checkbox"
                  id="requiresChecklist"
                  formControlName="requiresChecklist"
                  class="form-check-input">
                <label class="form-check-label" for="requiresChecklist">
                  Requer checklist na manutenção preventiva
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button type="button" class="btn-secondary" (click)="cancel()" [disabled]="isLoading">
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>
          <button type="submit" class="btn-primary" [disabled]="productForm.invalid || isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
            <i *ngIf="!isLoading" class="fa-solid fa-save me-2"></i>
            {{submitButtonText}}
          </button>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>
